import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { AppConstants } from "@core/constants";
import { CustomRendererService } from "@shared/services/custom-renderer.service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { TestEquipmentService } from "@shared/services/test-equipment/test-equipment.service";

@Injectable()
export class MyTestEquipmentResolver {
  private snackBar: MatSnackBar = inject(MatSnackBar);
  private customRendererService: CustomRendererService = inject(CustomRendererService);
  private testEquipmentService: TestEquipmentService = inject(TestEquipmentService);

  public resolve(): Observable<any> {
    return this.testEquipmentService.getTestEquipmentList()
      .pipe(
        catchError(error => {
          this.customRendererService.hide(AppConstants.MAT_SPINNER_CLASS);
          this.snackBar.open(error, 'OK', AppConstants.TOAST_CONFIG.ERROR);
          return of(null);
        }
        )
      )
  }
}
